import { router } from '@inertiajs/react';

declare global {
  interface Window {
    __csrfToken?: string;
  }
}

// Bootstrap initial token from the SSR-rendered Inertia page state.
// Inertia v3 (inertia-laravel ^3.0) renders the page JSON as the textContent
// of <script data-page="<id>" type="application/json">...</script>, sibling to
// the <div id="<id>"></div> mount point — NOT as a data-page attribute on #app
// like v2 did. See vendor/inertiajs/inertia-laravel/src/Directive.php.
function readInitialToken(): string | undefined {
  const scriptEl = document.querySelector('script[data-page][type="application/json"]');
  const pageData = scriptEl?.textContent;
  if (!pageData) return undefined;
  try {
    const page = JSON.parse(pageData) as { props?: { csrf_token?: string } };
    return page.props?.csrf_token;
  } catch {
    return undefined;
  }
}

window.__csrfToken = readInitialToken();

// Refresh token after every Inertia navigation in case the server rotated it
// (e.g. after login, logout, or any session()->regenerate()).
router.on('success', (event) => {
  const props = (event.detail?.page?.props ?? {}) as { csrf_token?: string };
  if (props.csrf_token) {
    window.__csrfToken = props.csrf_token;
  }
});
